import { useQuery } from '@tanstack/react-query';

import { AppClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const appClient = new AppClient(apiBaseUrl);

function useGetAppUserInfo() {
  return useQuery({
    queryKey: [queryKeys.App.AppUser],
    queryFn: () => appClient.getAppUserInfo(),
    staleTime: 5 * 60 * 1000,
  });
}

export default useGetAppUserInfo;
